export const ENV_CONFIG_KEY = 'minsu_env_config'

export enum APP_ENV {
  production = 'production',
  staging = 'staging',
  test = 'test',
}

export enum NODE_ENV {
  production = 'production',
  development = 'development',
  test = 'test',
}

export enum SHARE_CHANNEL {
  WEIXIN = 'weixin',
  TIMELINE = 'pengyouquan',
  DOWNLOAD = 'download',
  LINK = 'link',
}
